import NFTStaking from "./NFTStaking";

export default NFTStaking;
